import { onReady } from './add-this-script';
import GtmHelper from 'components/gtm-trigger/js/gtm-helper';

class ShareEventsObserver {
    start() {
        onReady(this._onReady);
    }

    _onReady = (shareThis) => {
        shareThis.forEach(toolbox => {
          toolbox.addEventListener('click', this._onMenuShare);
        })
    };

    _onMenuShare = (e) => {
        const network = e.target.dataset.network || (!!e.target.closest('[data-network]') && e.target.closest('[data-network]').dataset.network);
        if (network) {
            GtmHelper.send(null, {
                category: 'page',
                action: 'Share to Social',
                label: network
            });
        }
    };
}

export default new ShareEventsObserver();
